import React from 'react';
import Store from './Store';
import { Helmet } from "react-helmet";
import StoryContainer from './container/StoryContainer';
import './App.scss';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import ReactGA from "react-ga4";

let country = window.location.href.indexOf("usa") != -1 ? 'us' : 'uk';

if (country === 'us'){
  ReactGA.initialize("G-VCC3CN6RTR");
}else{
  ReactGA.initialize("G-5V73WL5TWH");
}
// ReactGA.initialize("G-9R3S0492XE");


function App() {
  return (
    <Store className="App">
      <Helmet>
        <meta name="robots" content="noindex"></meta>
        <script type="text/javascript" src="//script.crazyegg.com/pages/scripts/0130/4183.js" async="async" ></script>
      </Helmet>
      <Router>
        <Switch>
          <Route path="/:guid">
            <StoryContainer ></StoryContainer>
          </Route>
        </Switch>
      </Router>
    </Store>
  );
}

export default App;
